import {uniqueId} from "lodash";


export default class AccordionClass {

    data = []
    uid
    baseClass = ''
    lineClass = ''

    constructor() {

        this.uid = uniqueId()
    }

    bClass(c) {
        this.baseClass = c;
    }
    lClass(c) {
        this.lineClass = c;
    }

    add(title, content, options = {}) {
        this.data.push({'t': title, 'c': content, 'o':options })
        return 'x'+this.uid+'-'+(this.data.length-1)
    }

    html(){
        let out = $('<div>').addClass('accordion '+ this.baseClass).attr('id', this.uid)

        $(this.data).each((index, item) => {

            let id = this.uid+'-'+index
            let itemHtml = $('<div>').addClass('accordion-item '+ this.lineClass).addClass('x'+id).attr('id',item.o.id)
            let head = $('<h2>').addClass('accordion-header')
                .on('click',() => {
                    if(item.o.onOpen) item.o.onOpen()
                })
            let headHtml = $('<button>').addClass('accordion-button collapsed container-fluid')
                .attr({
                    'type': 'button',
                    'data-bs-toggle': 'collapse',
                    'data-bs-target': '#'+id,
                    'aria-controls': id,
                })
                .html(item.t)



            let body = $('<div>').addClass('accordion-collapse collapse')
                .attr({
                    'id': id,
                    'data-bs-parent': 'collapse'

                })
            let bodyHtml = $('<div>').addClass('accordion-body')
                .html(item.c)


            out.append(
                itemHtml.append(
                    head.append(headHtml),
                    body.append(bodyHtml)
                )
            )

        })


        return out

    }
}

